import type { JSX } from "react";

import { Avatar, type AvatarSize } from "@frontend/components/atoms/Avatar";

import type { EmployeeOption } from "../types";

export type EmployeeAvatarProps = {
  employee: EmployeeOption;
  className?: string;
  size?: AvatarSize;
};

/** The photo of an employee, or the mark of a person when none is on file. */
export function EmployeeAvatar({
  employee,
  className,
  size = "sm",
}: EmployeeAvatarProps): JSX.Element {
  return (
    <Avatar
      className={className}
      url={employee.hasPhoto ? (employee.avatarUrl ?? undefined) : undefined}
      size={size}
    />
  );
}
